/**
 * Contact Form.
 *
 * @format
 */

import React from 'react';
import ModalFormContainer from '../../form-components/form-containers/modal-form-container';
import { contactFormFields } from './contact-form-fields';

/**
 * Contact Fom Properties.
 */
interface ContactFormProperties {
  linkType: string;
  linkText: string;
  formType: string;
  region: string;
  hideLink: boolean;
}

/**
 * Contact Form.
 *
 * @param ContractFormProperties props
 * @returns
 */
const ContactForm = (props: ContactFormProperties): JSX.Element => {
  const { linkType, region, linkText, hideLink } = props;

  return (
    <ModalFormContainer
      formId={1094}
      formFields={contactFormFields}
      formType={'contact-form'}
      formTitle="Contact Us"
      linkType={linkType}
      linkText={linkText}
      region={region}
      hideLink={hideLink}
    />
  );
};
export default ContactForm;
